import { Component, computed, effect, inject } from '@angular/core';
import { SubmissionReviewComponent } from '@program-suite/ui-submission-review';
import { ModalLayoutComponent } from '@program-suite/ui';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SubmissionReviewViewModel } from '@program-suite/data-common/program';
import { ViewSubmissionStore } from '@program-suite/data-common';

@Component({
  selector: 'lib-submission-review-modal',
  imports: [SubmissionReviewComponent, ModalLayoutComponent],
  templateUrl: './submission-review-modal.component.html',
  styleUrl: './submission-review-modal.component.scss',
})
export class SubmissionReviewModalComponent {
  data: any = inject(MAT_DIALOG_DATA);
  dialogRef = inject(MatDialogRef<SubmissionReviewModalComponent>);
  viewSubmissionStore = inject(ViewSubmissionStore);

  constructor() {
    this.viewSubmissionStore.getSubmissionReview(this.data.id ?? '');
    this.viewSubmissionStore.getSubmissionDocuments(this.data.id ?? '', false);
  }

  ngOnDestroy(): void {
    this.viewSubmissionStore.setSubmissionReview(null);
  }
}